/* eslint-disable no-param-reassign */
import { createStore } from 'vuex';
import getDefaultState from './util';

// modules
import customer from './modules/customer';
import order from './modules/order';

export default (initialStateInjection = {}) => createStore({
  state: {
    ...getDefaultState(),
    ...initialStateInjection || {},
  },
  getters: {
    translations: (state) => state.translations,
    locale: (state) => state.locale,
  },
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
    setTranslations(state, translations) {
      state.translations = translations;
    },
  },
  actions: {
    reset({ dispatch, commit }) {
      commit('reset');
      dispatch('customer/reset');
      dispatch('order/reset');
    },
  },
  modules: {
    customer,
    order,
  },
});
